import React, { useEffect, useState } from "react";
// import Data from "../../../public/productData.json";
import axios from "axios";
import { removeSpaces } from "../utills/CommonData";
import { Link } from "react-router-dom";
import { useProductData } from "../../hooks/useProductData";
import ProductCard from "./ProductCard";
import ProductDataSets from "../../../src/Janica.products.json";

const Products = () => {
  const { productData, loading } = useProductData();

  const JsonProducts = productData?.length ? productData : ProductDataSets;

  return (
    <div className="grid 2xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 xs:grid-cols-2 grid-cols-1 place-items-center gap-5 sm:w-[90%] w-full relative mx-auto">
      {JsonProducts?.length &&
        JsonProducts.map((item) => {
          const { id } = item;
          return (
            <div key={id} className="">
              <ProductCard item={item} />
            </div>
          );
        })}
    </div>
  );
};

export default Products;
